import {queryOptions} from '@tanstack/react-query';
import {unwrap} from 'framework';
import type {WorkoutsDependencies} from '../dependencies';
import {keys} from './keys';

export type GetKeepScreenAwakePreferenceQueryDependencies = Pick<
  WorkoutsDependencies,
  'controllers'
>;

export const getKeepScreenAwakePreferenceQuery = ({
  controllers,
}: GetKeepScreenAwakePreferenceQueryDependencies) =>
  queryOptions({
    queryKey: keys.keepScreenAwake(),
    queryFn: () => controllers.workoutController.getKeepScreenAwakePreference().then(unwrap),
    staleTime: Number.POSITIVE_INFINITY,
  });
